import "../../App.css";
import Footer from "../Footer";
import OrderForm from "../OrderForm";
import Reveal from "../Reveal";
import Seo from "../Seo";
import "./Bestellen.css";

function Bestellen() {
    return (
        <>
            <Seo
                title="Bestellen"
                description="Plaats uw bestelling voor uw feest of evenement. Wij bevestigen de details binnen 24 uur."
                path="/bestellen"
            />
            <section className="bestellen-hero">
                <div className="bestellen-hero-content">
                    <span className="bestellen-eyebrow">BESTELLING PLAATSEN</span>
                    <h1 className="bestellen-title">
                        Plaats uw bestelling
                    </h1>
                    <div className="bestellen-rule" aria-hidden="true"></div>
                    <p className="bestellen-subtitle">
                        Rond uw bestelling af — wij bevestigen de details binnen 24 uur.
                    </p>
                </div>
            </section>

            <Reveal>
                <OrderForm mode="bestellen" />
            </Reveal>

            <Footer />
        </>
    );
}

export default Bestellen;
